import type { Vector3 } from "three/webgpu";

export type SpatialEntityRecord = {
  authoring: Vector3;
  semantic: Vector3;
  visual: Vector3;
};

export class SpatialEntityRegistry {
  private readonly records = new Map<string, SpatialEntityRecord>();

  register(id: string, authoring: Vector3, semantic: Vector3, visual: Vector3) {
    const record = { authoring, semantic, visual };
    this.records.set(id, record);
    return record;
  }

  get(id: string | null) {
    return id ? (this.records.get(id) ?? null) : null;
  }

  getAuthoring(id: string | null) {
    return this.get(id)?.authoring ?? null;
  }

  getSemantic(id: string | null) {
    return this.get(id)?.semantic ?? null;
  }

  getVisual(id: string | null) {
    return this.get(id)?.visual ?? null;
  }

  clear() {
    this.records.clear();
  }
}
